module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-92.394e54f.woff2";